module.exports = __webpack_public_path__ + "img/oasis-5.18c37df2.png";